import * as React from 'react';
import { IModule } from 'redux-state/layout/types.js';
import { AdvertModule } from '../../components-modules/advert/advert-module.js';
import { WarningsPanel } from '../../components-modules/warnings/panel/index.js';
import { componentWithErrorBoundary } from './module-error.js';

/** We put modules we want in the main bundle here. Its is lazy loaded it goes in the async bundle */
export const getModuleEager = (name: string): React.ComponentType<IModule> | undefined => {
  switch (name) {
    case 'warnings-panel': {
      const Component = componentWithErrorBoundary(WarningsPanel);
      return Component as unknown as React.ComponentType<IModule>;
    }
    case 'advert':
      return componentWithErrorBoundary(AdvertModule) as unknown as React.ComponentType<IModule>;
    default:
      return undefined;
  }
};
